export default "__VITE_ASSET__fmb_kmY0__"